import { CloudApi, CloudApiTransport, IDEMPOTENCY_KEY_HEADER } from '@yandex-360/telemost-sdk/cloud-api';

import getCloudApiUrl from '../get-cloud-api-url';
import { getUserUid } from '../get-user-uid';
import { SessionState } from '../session-state';
import { ChatApi } from './chat-api';

const cloudApiTransport = new CloudApiTransport({
    getBaseUrl: getCloudApiUrl,
    getInstanceId: () => SessionState.instanceId,
    getUid: getUserUid,
});

export { IDEMPOTENCY_KEY_HEADER };
export const cloudApi = new CloudApi(cloudApiTransport);
export const chatApi = new ChatApi();
